/**
 * 发文趋势图默认数据（接口未返回时使用，字段与后端 trendData 结构对齐）
 */
export default {
    keyword: '病因病机',
    dataVersion: '2026版',
    total: 477,
    startYear: 2003,
    endYear: 2023,
    peakYear: 2021,
    legendName: '病因病机',
    trendData: {
        xAxis: [
            '2003', '2004', '2005', '2006', '2007', '2008', '2009', '2010',
            '2011', '2012', '2013', '2014', '2015', '2016', '2017', '2018',
            '2019', '2020', '2021', '2022', '2023',
        ],
        series: [
            {
                name: '病因病机',
                data: [
                    2, 3, 4, 6, 8, 10, 12, 14,
                    16, 18, 20, 23, 26, 28, 30, 32,
                    35, 37, 39, 37, 35,
                ],
            },
        ],
    },
};
